<template>
	<div class="navigation-bottom-wrapper" :class="{ 'selected': selected }" @click="emit('clicked')">
		<div v-if="params.icon" class="icon-container">
			<component class="button-icon" :is="iconComponent"/>
		</div>
		<div class="display-text">{{params.text}}</div>
	</div>
</template>

<script setup>
/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/* Emmitters */
const emit = defineEmits(['clicked'])

/* props received
@params { Object } - object with:
    text {String} text to display in button, required field
    icon {String} icon name to display in button
@active {Boolean} prop to apply active classe
*/
const props = defineProps({
    params: { type: Object, required: true },
    selected: Boolean
})

const iconComponent = computed(() => {
    const icon = props.params.icon
    return defineAsyncComponent(() => import('@/assets/icons/' + icon + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.navigation-bottom-wrapper{
	width: 100%;
	height: 60px;
    padding-top: 12px;

	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;

	background-color: var(--secondary-light-3);
    border-top: 1px solid var(--secondary-light-1);
	position: relative;

	.icon-container{
		width: 24px;
		height: 24px;

		display: flex;
		align-items: center;
		justify-content: center;

		.button-icon{
			width: 24px;
			height: 24px;

			:deep(.change-color-fill) {
				fill: var(--secondary);
			}
		}
	}

	.display-text{
		@include H8-Medium;
		color: var(--secondary);
	}

	&:active {
        background-color: var(--secondary-light-1);
    }

	&.selected {
		background-color: var(--secondary-light-4);
        border-top: 1px solid var(--primary);

		&:before {
			content: '';
			width: 100%;
			height: 2px;

			position: absolute;
			top: 0;
			left: 0;

			background-color: var(--primary);
		}

		.icon-container {
			.button-icon {
				:deep(.change-color-fill) {
					fill: var(--primary);
				}
			}
		}

		.display-text {
			color: var(--primary);
		}
	}
}
</style>
